export default {
    path: '/applicants',
    name: 'landing-page-applicants',
    component: () => import('source/pages/LandingApplicants.vue'),
    meta: {
        title: 'HQZen - Find your next job',
    },
};
